import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { TextEnableLandlineStore } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/store/textEnableLandlineStore'

const TextEnableLandlineContext = createContext<TextEnableLandlineStore | null>(null)

export const useTextEnableLandlineContext = () => {
  const context = useContext(TextEnableLandlineContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with TextEnableLandlineContext')

  return context
}

export const TextEnableLandlineProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const inboxLayerStore = useInboxLayerContext()
  const store = useMemo(
    () => new TextEnableLandlineStore(inboxLayerStore, entities),
    [inboxLayerStore, entities]
  )
  const { search } = useLocation()

  useEffect(() => {
    store.init(search)

    return () => {
      store.dispose()
    }
  }, [store])

  return (
    <TextEnableLandlineContext.Provider value={store}>
      {children}
    </TextEnableLandlineContext.Provider>
  )
}
